'use strict';
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024 from "./app.data.-User-Details$package$-User-First-Name$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024 from "./app.data.-User-Details$package$-User-Last-Name$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024 from "./app.data.-User-Details$package$-User-Middle-Name$.js";
import * as $j_app$002epages$002e$002dApp$002dPage$0024$002dRoot$0024 from "./app.pages.-App-Page$-Root$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_auth_package$() {
  this.axg = null;
  this.axh = false;
  this.axe = null;
  this.axf = false;
  this.axi = null;
  this.axj = false;
}
export { $c_Lapp_auth_package$ as $c_Lapp_auth_package$ };
$p = $c_Lapp_auth_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_auth_package$;
/** @constructor */
function $h_Lapp_auth_package$() {
}
export { $h_Lapp_auth_package$ as $h_Lapp_auth_package$ };
$h_Lapp_auth_package$.prototype = $p;
$p.bBu = (function() {
  if ((!this.axh)) {
    this.axg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$RootPage$(this);
    this.axh = true;
  }
  return this.axg;
});
$p.cl = (function() {
  if ((!this.axf)) {
    this.axe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState$(this);
    this.axf = true;
  }
  return this.axe;
});
$p.bVj = (function() {
  if ((!this.axj)) {
    this.axi = $m_Lapp_auth_package$().bBu().bDf($j_app$002epages$002e$002dApp$002dPage$0024$002dRoot$0024.$m_Lapp_pages_AppPage$Root$());
    this.axj = true;
  }
  return this.axi;
});
$p.bGZ = (function(state) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option(state);
  var this$2 = (this$1.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$1.g().mQ.VN().a4X()));
  return (this$2.c() ? state.DT().bqy() : this$2);
});
$p.bIo = (function(state) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option(state);
  if (this$1.c()) {
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$1.g();
    var this$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(arg1.mQ.VN().z4, $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024.$m_Lapp_data_UserDetails$package$UserFirstName$().aA());
    var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$4.bq.aT(this$4.bp));
  }
  return (this$5.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IndexedSeqOps__headOption__s_Option(state.DT().arD()) : this$5);
});
$p.bQG = (function(state) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option(state);
  if (this$1.c()) {
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$1.g();
    var this$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(arg1.mQ.VN().z6, $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024.$m_Lapp_data_UserDetails$package$UserMiddleName$().aA());
    var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$4.bq.aT(this$4.bp));
  }
  if (this$5.c()) {
    var this$6 = state.DT().arD();
    var this$7 = this$6.wq(1, this$6.q());
    var this$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(this$7.wq(0, (((-1) + this$7.q()) | 0)), "", " ", "")));
    return ((this$11.c() || (!$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__isBlank__Z(this$11.a7))) ? this$11 : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  } else {
    return this$5;
  }
});
$p.bPQ = (function(state) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_data_AuthPlatformForClientAndServerSideAuth$ClientAuthState__asAuthenticated__s_Option(state);
  if (this$1.c()) {
    var this$5 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$1.g();
    var this$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(arg1.mQ.VN().z5, $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024.$m_Lapp_data_UserDetails$package$UserLastName$().aA());
    var this$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this$4.bq.aT(this$4.bp));
  }
  return (this$5.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOps__lastOption__s_Option(state.DT().arD()) : this$5);
});
$p.a6x = (function(signal) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_SignalExts$package$().ah3(signal).jf(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$7) => _$7.DT().ah6())));
});
$p.bXG = (function(signal) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_SignalExts$package$().ah3(signal).jf(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$8) => _$8.DT().bwy())));
});
var $d_Lapp_auth_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_auth_package$, "app.auth.package$", ({
  yO: 1,
  Wf: 1
}));
export { $d_Lapp_auth_package$ as $d_Lapp_auth_package$ };
var $n_Lapp_auth_package$;
function $m_Lapp_auth_package$() {
  if ((!$n_Lapp_auth_package$)) {
    $n_Lapp_auth_package$ = new $c_Lapp_auth_package$();
  }
  return $n_Lapp_auth_package$;
}
export { $m_Lapp_auth_package$ as $m_Lapp_auth_package$ };
//# sourceMappingURL=app.auth.package$.js.map
